import React from "react";
import { useTranslation } from "react-i18next";
import { ListItem, TrashIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import ConfirmLink from "~/components/component.confirm_link";
import i18n from "~/i18n";

const trashTranslationMap = {
  discussion: {
    title: i18n.t("Delete discussion?"),
    description: i18n.t("The discussion will remain in Trash for 30 days."),
  },
  note: {
    title: i18n.t("Delete note?"),
    description: i18n.t("The note will remain in Trash for 30 days."),
  },
  notebook: {
    title: i18n.t("Delete notebook?"),
    description: i18n.t("The notebook will remain in Trash for 30 days."),
  },
  time_record: {
    title: i18n.t("Delete time record?"),
    description: i18n.t("The time record will remain in Trash for 30 days."),
  },
  expense: {
    title: i18n.t("Delete expense?"),
    description: i18n.t("The expense will remain in Trash for 30 days."),
  },
  item: {
    title: i18n.t("Delete item?"),
    description: i18n.t("The item will remain in Trash for 30 days."),
  },
  event: {
    title: i18n.t("Delete Event?"),
    description: i18n.t("The event will remain in Trash for 30 days."),
  },
};

export const TrashOption = ({ onMoveToTrash, type }) => {
  const { t } = useTranslation();
  const { title, description } = trashTranslationMap[trashTranslationMap[type] ? type : "item"];

  return (
    <ConfirmLink
      data-testid="confirm-dialogue"
      className="tw-no-underline"
      title={title}
      description={description}
      confirmLabel={t("Delete")}
      cancelLabel={t("Cancel")}
      onClick={onMoveToTrash}
    >
      <ListItem>
        <TrashIcon className="tw-fill-theme-900" />
        {t("Delete")}
      </ListItem>
    </ConfirmLink>
  );
};

TrashOption.propTypes = {
  onMoveToTrash: PropTypes.func,
  type: PropTypes.string,
};

TrashOption.defaultProps = {
  type: "discussion",
};
